<template>
	<Skeleton :paragraph="{ rows: 13 }" :title="false" :loading="isLoading">
		<div class="ftp-settings-item" v-for="ftpItemSettings in settings" :key="ftpItemSettings.key">
			{{ $t('settings.vrsSettingsForm.ftpSettings.' + ftpItemSettings.key) }}
			<Button type="link" @click="ftpSettingsClick(ftpItemSettings.key)">
				<template #icon>
					<EditOutlined />
				</template>
			</Button>
			<Tooltip :title="$t('settings.vrsSettingsForm.ftpSettings.recheckTooltip')">
				<Button v-if="ftpItemSettings.currentValue.status !== 'checked'" type="link" @click="recheckFtpSettings">
					<template #icon>
						<ReloadOutlined />
					</template>
				</Button>
			</Tooltip>
			<br>
			<TypographyText code>{{ ftpItemSettings.currentValue.fullAddress }}</TypographyText><br>
			<StatusDisplay
				:source="ftpItemSettings.currentValue"
				field="status"
				prefix="settings.vrsSettingsForm.ftpSettings.status"
				:badgeDict="STATUS_BADGES"
			/>
			<TypographyParagraph v-if="ftpItemSettings.currentValue.status === 'failed'">
				<pre>{{ ftpItemSettings.currentValue.statusMessage }}</pre>
			</TypographyParagraph>
		</div>
		<TaskRunButton taskLabel="run_script_downloader_forced" buttonLabel="settings.vrsSettingsForm.runDownloadButtonLabel" :disabled="!runDownloaderEnabled" />
	</Skeleton>
	<FTPSettingsModal v-model="isModalVisible" :item="ftpItemSettingsForModal" :onFTPSettingsUpdate="fetchSettings" />
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Button, Skeleton, TypographyText, TypographyParagraph, Tooltip } from 'ant-design-vue';
import { EditOutlined, ReloadOutlined } from '@ant-design/icons-vue';

import Api from '@/api/Api';
import { toCamelCase } from '@/api/ApiHelpers';
import Consts from '@/api/Consts';

import TaskRunButton from '@/components/common/TaskRunButton';
import StatusDisplay from '@/components/common/StatusDisplay.vue';
import FTPSettingsModal from '@/components/settings/FTPSettingsModal.vue';


const STATUS_BADGES = {
	verification: 'processing',
	checked: 'success',
	failed: 'error',
}

export default {
	components: {
		Button, Skeleton, TypographyText, TypographyParagraph, Tooltip,
		EditOutlined, ReloadOutlined,
		TaskRunButton, StatusDisplay, FTPSettingsModal,
	},
	setup() {
		const isLoading = ref(true);
		const isModalVisible = ref(false);
		const settings = ref([]);
		const ftpItemSettingsForModal = ref(null);

		const fetchSettings = () => {
			isLoading.value = true;
			Api.vrsFTPSettingsGet(responseData => {
				settings.value = responseData.settings.map(item => ({
					key: item.key,
					currentValue: {
						...toCamelCase(item.value),
					},
					defaultValue: item.default == null ? null : toCamelCase(item.default),
				}));
				isLoading.value = false;
			});
		}

		onMounted(() => {
			fetchSettings();
		});

		const runDownloaderEnabled = computed(() => {
			return settings.value.every(item => item.currentValue.status === 'checked');
		});
		const ftpSettingsClick = (key) => {
			isModalVisible.value = true;
			ftpItemSettingsForModal.value = settings.value.filter(item => item.key === key)[0];
		}
		const recheckFtpSettings = () => {
			isLoading.value = true;
			Api.vrsFTPSettingsRecheck(() => {
				isLoading.value = false;
				fetchSettings();
			});
		}


		return {
			STATUS_BADGES,
			isLoading,
			isModalVisible,
			settings,
			ftpItemSettingsForModal,
			runDownloaderEnabled,
			fetchSettings,
			ftpSettingsClick,
			recheckFtpSettings,
			paddingMd: Consts.CSS.paddingMd,
		};
	},
}
</script>

<style scoped>
.ftp-settings-item {
	padding-bottom: v-bind(paddingMd);
}
</style>

<style>
.ftp-settings-item .ant-badge {
	margin-top: 2px;
}

.ftp-settings-item .ant-badge-status-text {
	font-size: 12px;
}
</style>
